const playersInitialState = {
  players: []
};

export default playersInitialState;
